import graphql from './graphql';

const query = /* GraphQL */ `
  query Lesson_count($moduleId: ID) {
    Lesson_count(moduleId: $moduleId) {
      count
    }
  }
`;

const LessonCount = async ({ moduleId }) =>
  // eslint-disable-next-line camelcase
  graphql(query, { moduleId }).then(({ Lesson_count }) => Lesson_count);

export default LessonCount;
